module.exports = __webpack_public_path__ + "static/img/Power_Electronics_Lab1.c4e246b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/Power_Electronics_Lab1.jpg
// module id = i9fL
// module chunks = 0